define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "moment", "../services"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, moment_1, services_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HarvestingPermit = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    class HarvestingPermit extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalHarvestingDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalHarvestingDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, HarvestingPermit.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.StartDt = b.StartDt;
            a.EndDt = b.EndDt;
            a.HarvestingDays = (0, EntityUtil_1.toInt)(entity.HarvestingDays);
            a.HarvestingArea = (0, EntityUtil_1.toFloat)(entity.HarvestingArea);
            a.FinalStartDt = b.FinalStartDt;
            a.FinalEndDt = b.FinalEndDt;
            a.FinalHarvestingDays = (0, EntityUtil_1.toInt)(entity.FinalHarvestingDays);
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 500);
            this.addChangeEventAction("StartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("EndDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalStartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalEndDt", this.onChangeBatchFn.bind(this));
            if (this.Permit) {
                this.Permit.addChangeEventAction("FeeApplicationRule", this.onChangeBatchFn.bind(this));
                this.Permit.addChangeEventAction("FeePermitRule", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, HarvestingPermit.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.Permit.IsActive && this.Permit.License.IsPendingApprovalOrApproved) {
                this._validate(validationState, recurseChildren);
                if (this.StartDt > this.EndDt) {
                    this.StartDtError = "Permit end date must not preceed its start date";
                    validationState.addError(this.StartDtError);
                }
                else {
                    this.StartDtError = "";
                }
                if (this.FinalStartDt > this.FinalEndDt) {
                    this.FinalStartDtError = "Actual Permit end date must not preceed its actual start date";
                    validationState.addError(this.FinalStartDtError);
                }
                else {
                    this.FinalStartDtError = "";
                }
                let noOfHarvestingDays = (0, moment_1.default)(this.EndDt).diff((0, moment_1.default)(this.StartDt), "days") + 1;
                let maxHarvestingDays = services_1.AppConfigManager.InstanceSync.getHarvestingPermitTimeRule(this.Permit).MaxPermitDays;
                if (noOfHarvestingDays > maxHarvestingDays) {
                    this.HarvestingDaysError = `The number of permit days can not exceed ${maxHarvestingDays} days`;
                    validationState.addError(this.HarvestingDaysError);
                }
                else {
                    this.HarvestingDaysError = "";
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "PermitId", "Permit Id");
                this.validateReqDate(validationState, "StartDt", "Start Date");
                this.validateReqDate(validationState, "EndDt", "End Date");
                this.validateReqNumber(validationState, "HarvestingDays", "Harvesting Days");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                StartDt: this.StartDt,
                EndDt: this.EndDt,
                HarvestingDays: this.HarvestingDays,
                HarvestingArea: this.HarvestingArea,
                FinalStartDt: this.FinalStartDt,
                FinalEndDt: this.FinalEndDt,
                FinalHarvestingDays: this.FinalHarvestingDays,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onChange(change) {
            if (this.Permit) {
                this.disableChangeObserver();
                this.calculateDates(change);
                this.enableChangeObserver();
            }
        }
        calculateDates(change) {
            if (change) {
                if (!this.Permit.License.IsPersistedStatePendingApprovalOrApproved) {
                    if (change.name == "StartDt") {
                        this.EndDt = (0, moment_1.default)(this.StartDt).add(this.HarvestingDays, "days").valueOf();
                        this.FinalEndDt = this.EndDt;
                        this.FinalStartDt = this.StartDt;
                        this.HarvestingDays = (0, moment_1.default)(this.EndDt).diff((0, moment_1.default)(this.StartDt), "days") + 1;
                        this.FinalHarvestingDays = this.HarvestingDays;
                    }
                    else if (change.name == "EndDt") {
                        this.HarvestingDays = (0, moment_1.default)(this.EndDt).diff((0, moment_1.default)(this.StartDt), "days") + 1;
                        this.FinalHarvestingDays = this.HarvestingDays;
                        this.FinalStartDt = this.StartDt;
                        this.FinalEndDt = this.EndDt;
                    }
                }
                else if (change.name == "FinalStartDt" || change.name == "FinalEndDt") {
                    this.FinalHarvestingDays = (0, moment_1.default)(this.FinalEndDt).diff((0, moment_1.default)(this.FinalStartDt), "days") + 1;
                }
            }
        }
    }
    exports.HarvestingPermit = HarvestingPermit;
    Object.defineProperty(HarvestingPermit, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "HarvestingPermit"
    });
    Object.defineProperty(HarvestingPermit, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Harvesting Permit"
    });
    Object.defineProperty(HarvestingPermit, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "StartDt", "EndDt", "HarvestingDays", "HarvestingArea", "FinalStartDt", "FinalEndDt", "FinalHarvestingDays", "Shape"]
    });
    Object.defineProperty(HarvestingPermit, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(HarvestingPermit, "StartDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the expected start date of the harvest"
    });
    Object.defineProperty(HarvestingPermit, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(HarvestingPermit, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(HarvestingPermit, "HarvestingDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(HarvestingPermit, "HarvestingAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(HarvestingPermit, "FinalStartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(HarvestingPermit, "FinalEndDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the date that the harvest was completed"
    });
    Object.defineProperty(HarvestingPermit, "FinalEndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(HarvestingPermit, "FinalHarvestingDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "HarvestingDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "HarvestingDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "HarvestingArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "HarvestingAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalStartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalStartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalEndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalEndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalHarvestingDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "FinalHarvestingDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], HarvestingPermit.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], HarvestingPermit.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], HarvestingPermit.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], HarvestingPermit.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.action
    ], HarvestingPermit.prototype, "onChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], HarvestingPermit.prototype, "calculateDates", null);
});
